
import React from "react";
import { ActivityTypeIcon } from "@/components/activities/ActivityTypeIcon";
import { ActivityStatus } from "@/components/activities/ActivityStatus";
import { getActivityTypeName } from "@/components/activities/utils/activityUtils";
import { Activity } from "@/components/activities/schema/activitySchema";

interface ActivityDetailHeaderProps {
  activity: Activity;
}

export const ActivityDetailHeader: React.FC<ActivityDetailHeaderProps> = ({ 
  activity 
}) => {
  return (
    <div className="flex justify-between items-start mb-4">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <ActivityTypeIcon type={activity.activity_type} size={20} />
          <span className="text-sm text-gray-600 dark:text-gray-400">
            {getActivityTypeName(activity.activity_type)}
          </span>
        </div>
        <h1 className="text-2xl font-semibold">{activity.title}</h1>
      </div>
      <ActivityStatus status={activity.status} size="md" />
    </div>
  );
};
